import { Component, effect } from '@angular/core';
import { Router } from '@angular/router';
import { changeMfaRoute, changePasswordRoute } from '../route-names';
import { DecisionDialogService, DialogType } from '../Services/decision-dialog.service';
import { ElectorDataService, IdvStatus } from '../Services/elector-data.service';
import { SessionService } from '../Services/session.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ReceiptCodeComponent } from '../receipt-code/receipt-code.component';
import { ApiAboutService } from '../Services/api-about.service';

@Component({
    selector: 'app-user-menu',
    templateUrl: './user-menu.component.html',
    styleUrl: './user-menu.component.scss',
    standalone: false
})
export class UserMenuComponent {
  idvStatus: IdvStatus = 'NONE';

  constructor(
    private dialog: MatDialog,
    public electorDataService: ElectorDataService,
    public decisionDialogService: DecisionDialogService,
    readonly sessionService: SessionService,
    private readonly aboutService: ApiAboutService,
    readonly router: Router) {
    effect(() => {
      this.idvStatus = this.electorDataService.idvStatus()
    });
  }

  logout() {
    const dialogRef = this.decisionDialogService.openDialog(
      DialogType.CONFIRM,
      $localize`Confirm Logout`,
      $localize`Are you sure you want to log out?`,
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.sessionService.endSession()
      }
    });
  }

  changePassword() {
    this.router.navigate(changePasswordRoute);
  }

  changeMFA() {
    this.router.navigate(changeMfaRoute);
  }

  receiptCode(){
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.panelClass ='receipt-dialog';
    dialogConfig.data = { code: this.electorDataService.receiptCode() }; 
    dialogConfig.ariaDescribedBy = 'dialog-content'
    this.dialog.open(ReceiptCodeComponent, dialogConfig);
  }

  refresh() {
    this.electorDataService.updateDashboard();
  }

  refreshLocked(): boolean {
    return this.electorDataService.isDashBoardUpdateLocked;
  }

  showIDVstatus(): boolean {
    return ['VMA', 'VWA_ID'].includes(this.electorDataService.userType)
  }

  showChangePassword(): boolean {
    return (this.aboutService.hasDashboard && (this.electorDataService.userType !== 'VMA'));
  }

  showChangeMfa(): boolean {
    return this.aboutService.hasDashboard;
  }

  showRefreshDashboard(): boolean {
    return this.aboutService.hasDashboard;
  }
}
